import React from "react";
import { Dropdown } from "react-bootstrap";
import styled from "styled-components";
import { colors } from "utils";

const EllipsisIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="1" />
    <circle cx="12" cy="5" r="1" />
    <circle cx="12" cy="19" r="1" />
  </svg>
);

const ToggleButton = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  color: ${(props) => (props.$onDark ? "#fff" : colors.nightlyWoods500)};
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  padding: 0;
`;

const MenuToggle = React.forwardRef(({ children, onClick, "aria-label": ariaLabel, $onDark }, ref) => (
  <ToggleButton
    type="button"
    ref={ref}
    aria-label={ariaLabel}
    $onDark={$onDark}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </ToggleButton>
));

// Scopes the ⋮ menu styling (Figma Menu/Group Card): white menu, blue/300
// border, 6px radius, blue/50 hover — overriding the page's default
// react-bootstrap dropdown styles.
const MenuScope = styled.div`
  display: inline-flex;

  .dropdown-menu {
    border: 1px solid ${colors.blue300};
    border-radius: 6px;
    box-shadow: 0px 4px 12px rgba(14, 26, 49, 0.12);
    min-width: 172px;
    overflow: hidden;
    padding: 0;
  }
  .dropdown-item {
    color: ${colors.nightlyWoods500};
    font-family: "Inter", sans-serif;
    font-size: 14px;
    line-height: 20px;
    padding: 8px;
  }
  .dropdown-item:hover,
  .dropdown-item:focus,
  .dropdown-item.active {
    background: ${colors.blue50};
    color: ${colors.nightlyWoods500};
  }
  .dropdown-item:disabled {
    color: ${colors.gray700};
  }
`;

// items: [{ label, onClick, disabled?, title? }]
export const KebabMenu = ({ ariaLabel, onDark = false, items }) => (
  <MenuScope>
    <Dropdown align="end">
      <Dropdown.Toggle as={MenuToggle} aria-label={ariaLabel} $onDark={onDark}>
        <EllipsisIcon />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {items.map((item) => (
          <Dropdown.Item as="button" key={item.label} disabled={item.disabled} title={item.title} onClick={item.onClick}>
            {item.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  </MenuScope>
);
